<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fmh3"><a id="page_xxiv"></a><a id="page_xxv"></a><span class="bold">List of Plates</span></h2>
<p class="entry"><span href="#/xhtml/30_Plates_Section#photo1" title="Link target outside of Sample">The bronze statue of Hotspur in Alnwick</span></p>
<p class="entry"><span href="#/xhtml/30_Plates_Section#photo2" title="Link target outside of Sample">‘Arms of Sir Henry Percy’</span></p>
<p class="entry"><span href="#/xhtml/30_Plates_Section#photo3" title="Link target outside of Sample">Alnwick Castle</span></p>
<p class="entry"><span href="#/xhtml/30_Plates_Section#photo4" title="Link target outside of Sample">Warkworth Castle</span></p>
<p class="entry"><span href="#/xhtml/30_Plates_Section#photo5" title="Link target outside of Sample">Bamburgh Castle</span></p>
<p class="entry"><span href="#/xhtml/30_Plates_Section#photo6" title="Link target outside of Sample">The walls of Berwick-upon-Tweed</span></p>
<p class="entry"><span href="#/xhtml/30_Plates_Section#photo7" title="Link target outside of Sample">The remains of the castle at Berwick</span></p>
<p class="entry"><span href="#/xhtml/30_Plates_Section#photo8" title="Link target outside of Sample">Dunstanburgh Castle</span></p>
<p class="entry"><span href="#/xhtml/30_Plates_Section#photo9" title="Link target outside of Sample">Facsimile armour of the fourteenth century</span></p>
<p class="entry"><span href="#/xhtml/30_Plates_Section#photo10" title="Link target outside of Sample">Newcastle Keep</span></p>
<p class="entry"><span href="#/xhtml/30_Plates_Section#photo11" title="Link target outside of Sample">The Otterburn battlefield memorial</span></p>
<p class="entry"><span href="#/xhtml/30_Plates_Section#photo12" title="Link target outside of Sample">A general view of Otterburn battlefield</span></p>
<p class="entry"><span href="#/xhtml/30_Plates_Section#photo13" title="Link target outside of Sample">Looking east at Otterburn</span></p>
<p class="entry"><span href="#/xhtml/30_Plates_Section#photo14" title="Link target outside of Sample">The Silloans Sword</span></p>
<p class="entry"><span href="#/xhtml/30_Plates_Section#photo15" title="Link target outside of Sample">The replica Silloans Sword</span></p>
<p class="entry"><span href="#/xhtml/30_Plates_Section#photo16" title="Link target outside of Sample">Elsdon church</span></p>
<p class="entry"><span href="#/xhtml/30_Plates_Section#photo17" title="Link target outside of Sample">The Neville effigies, Staindrop church</span></p>
<p class="entry"><span href="#/xhtml/30_Plates_Section#photo18" title="Link target outside of Sample">A medieval spur, recovered from the vicinity of Albright Hussey</span></p>
<p class="entry"><span href="#/xhtml/30_Plates_Section#photo19" title="Link target outside of Sample">Otterburn battlefield walk participants</span></p>
<p class="entry"><span href="#/xhtml/30_Plates_Section#photo20" title="Link target outside of Sample">An aerial view of Battlefield church and its environs in Shrewsbury</span></p>
<p class="entry"><span href="#/xhtml/30_Plates_Section#photo21" title="Link target outside of Sample">Battlefield church</span></p>
<p class="entry"><span href="#/xhtml/30_Plates_Section#photo22" title="Link target outside of Sample">The effigy of Simon Mewburn, Church of St John of Beverley, St John’s Lee</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 10_Plates.vue?feaac1a2